import React from 'react';
import { Box } from '@mui/material';
import { ResponseDockMark } from '@responsedock/ui/brand';

interface ResponseDockLogoProps {
  size?: number;
  showText?: boolean;
}

export function ResponseDockLogo({ size = 32, showText = true }: ResponseDockLogoProps) {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      <ResponseDockMark size={size} />
      {showText && (
        <Box
          component="span"
          sx={{
            fontWeight: 800,
            fontSize: size * 0.56,
            letterSpacing: '-0.02em',
            background: 'linear-gradient(135deg, #E649A9 0%, #A21CAF 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            lineHeight: 1,
            userSelect: 'none',
          }}
        >
          ResponseDock
        </Box>
      )}
    </Box>
  );
}
